import DifferenceIcon from '@mui/icons-material/Difference';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import PowerIcon from '@mui/icons-material/Power';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import { Box, Chip, type Palette, type PaletteColor, type Theme, Tooltip, useTheme } from '@mui/material';
import { Mutation as MutationIcon, Query as QueryIcon, Shape as ShapeIcon } from 'app/common/icons';
import type React from 'react';
import type { DiffItem } from '../schema-diff/schema-diff.js';

export type SchemaDiffItemProps = {
  readonly diffItem: DiffItem;
  readonly section: string;
};

const colors: Record<string, keyof Theme> = {
  N: 'added' as keyof Theme,
  D: 'removed' as keyof Theme,
  E: 'edited' as keyof Theme,
  A: 'edited' as keyof Theme
};

export const SchemaDiffItem: React.FC<SchemaDiffItemProps> = (props) => {
  const { diffItem, section } = props;
  const theme = useTheme();
  const themeColor = theme[colors[diffItem.kind]];
  const bgcolor = themeColor ? (themeColor as Palette).background : theme.palette.primary.main;
  const color = themeColor ? (themeColor as PaletteColor).main : theme.palette.primary.light;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: 0.5,
        borderRadius: 1,
        gap: 1,
        marginBottom: 1,
        bgcolor: bgcolor as string
      }}
    >
      {section === 'shapes' && (
        <Tooltip title="Shape" placement="left">
          <div>
            <ShapeIcon sx={{ color }} />
          </div>
        </Tooltip>
      )}
      {section === 'queries' && (
        <Tooltip title="Query" placement="left">
          <div>
            <QueryIcon sx={{ color }} />
          </div>
        </Tooltip>
      )}
      {section === 'mutations' && (
        <Tooltip title="Mutation" placement="left">
          <div>
            <MutationIcon sx={{ color }} />
          </div>
        </Tooltip>
      )}
      {section === 'forms' && (
        <Tooltip title="Form" placement="left">
          <KeyboardIcon sx={{ color }} />
        </Tooltip>
      )}
      {section === 'services' && (
        <Tooltip title="Service" placement="left">
          <PowerIcon sx={{ color }} />
        </Tooltip>
      )}
      {section === 'indexedShapes' && (
        <Tooltip title="Indexed Shapes" placement="left">
          <SyncAltIcon sx={{ color }} />
        </Tooltip>
      )}
      {section === 'other' && (
        <Tooltip title="Diff Path" placement="left">
          <DifferenceIcon sx={{ color }} />
        </Tooltip>
      )}
      <Box sx={{ flexGrow: 1, overflowWrap: 'anywhere' }}>{diffItem.label}</Box>
      {diffItem.kind === 'N' && <Chip label="Added" sx={{ color: 'white', bgcolor: color }} size="small" />}
      {diffItem.kind === 'D' && <Chip label="Removed" sx={{ color: 'white', bgcolor: color }} size="small" />}
      {(diffItem.kind === 'E' || diffItem.kind === 'A') && (
        <Chip label="Edited" sx={{ color: 'white', bgcolor: color }} size="small" />
      )}
    </Box>
  );
};
